module.exports = __webpack_public_path__ + "files/2ad5ba6dd59c3988ba7d77f6d6997b30.png";